var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('highlight-code',{attrs:{"lang":"cypher"}},[_vm._v(" "+_vm._s(_vm.cypherQuery)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }